import React, { useEffect, useState } from 'react'

const CustomBlock =  ({htmlBlockKey}) => {
  const [customHtml, setCustomHtml] = useState(undefined)

  useEffect(() => {
    axios.post('/api/custom-html', { pathname: htmlBlockKey }).then((response) => {
      setCustomHtml(response.data)
    })
  }, [htmlBlockKey])
  return <div dangerouslySetInnerHTML={{ __html: customHtml }} />
}

export default CustomBlock